import { LEGACY_COURSE_ID, useCourses } from 'hooks/useCourses';
import { CourseLayout } from 'pages/online-trainings/hand-hygiene/course-layout';
import { CourseLayout as CourseLayoutOld } from 'pages/online-trainings-old/hand-hygiene/course-layout';
import { useParams } from 'react-router-dom';

export const SmartCourseLayout = () => {
    const { coursePath } = useParams<{ coursePath: string }>();
    const { allCoursesData, isLoadingCourses } = useCourses();

    if (isLoadingCourses) return null;

    const course = allCoursesData.find((c) => c.path === coursePath);

    if (course?.id === LEGACY_COURSE_ID) {
        return <CourseLayoutOld />;
    }

    return <CourseLayout />;
};
